import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { RootLayout } from "@/app/layouts";
import { HomePage } from "@/pages/home";
import { ClientCampaignsPage } from "@/pages/client-campaigns";
import { CampaignDetailsPage } from "@/pages/campaign-details";
import { CampaignStatisticsPage } from "@/pages/campaign-statistics";
import { ProblematicCampaignsPage } from "@/pages/problematic-campaigns";
import { LoginPage } from "@/pages/login";
import { AuthCallbackPage } from "@/pages/auth-callback";
import { AuthGuard, GuestGuard } from "./AuthGuard";

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        path: "/",
        element: (
          <AuthGuard>
            <HomePage />
          </AuthGuard>
        ),
      },
      {
        path: "/problems",
        element: (
          <AuthGuard>
            <ProblematicCampaignsPage />
          </AuthGuard>
        ),
      },
      {
        path: "/campaign/:id",
        element: (
          <AuthGuard>
            <CampaignDetailsPage />
          </AuthGuard>
        ),
      },
      {
        path: "/campaign/:id/statistics",
        element: (
          <AuthGuard>
            <CampaignStatisticsPage />
          </AuthGuard>
        ),
      },
      {
        path: "/login",
        element: (
          <GuestGuard>
            <LoginPage />
          </GuestGuard>
        ),
      },
      {
        path: "/auth/callback",
        element: <AuthCallbackPage />,
      },
      {
        path: "/:client/problems",
        element: (
          <AuthGuard>
            <ProblematicCampaignsPage />
          </AuthGuard>
        ),
      },
      {
        path: "/:client",
        element: (
          <AuthGuard>
            <ClientCampaignsPage />
          </AuthGuard>
        ),
      },
    ],
  },
]);

export const AppRouterProvider = () => {
  return <RouterProvider router={router} />;
};
